// some default challenges for user to choose from
// only include info that is needed, the rest of the fields will be filled as empty when the challenge is created
export const premadeChallenges =
    [
        {
            id: 4,
            title: "5 min Cardio Stationary Bike",
            description: "Get your daily cardio in",
            dateCreated: "2025-12-03",
            videoId: "PH-kqdzTgqE"
        },
        {
            id: 2,
            title: "5 min Dribbling Workout",
            description: "Improve your basketball handles with a quick 5 minute workout",
            dateCreated: "2025-11-12",
            videoId: "oADaM2L1YLc"
        },
        {
            id: 1,
            title: "5 min Ab Workout",
            description: "Quick ab workout to strengthen core",
            dateCreated: "2025-11-12",
            videoId: "j2QmtQ_tHaw"
        },
        {
            id: 3,
            title: "5 min Spanish Practice",
            description: "Practice Spanish on Duolingo for 5 minutes",
            dateCreated: "2025-11-12",
            notes: "Try to complete 1-2 lessons."
        },
        {
            id: 5,
            title: "5 min Reading",
            description: "Read a book for 5 minutes every day",
            dateCreated: "2025-12-03",
            notes: "How many pages can you read in 5 minutes?"
        },

    ];
